import { type FunctionalComponent, h } from "preact";
import { isEmptyString } from "@shared/Utils";
import type { ArticleModel } from "../magazine.service";
import { ArticleCard } from "./article-card";

export interface RelatedArticlesProps {
  articles: ArticleModel[];
  magazineUrl?: string;
  showIngress?: boolean;
  relatedTitle: string;
}

export const relatedArticles: FunctionalComponent<RelatedArticlesProps> = ({
  articles,
  magazineUrl = "",
  showIngress = true,
  relatedTitle,
}: RelatedArticlesProps) => {
  const hasArticles = articles && articles.length > 0;
  return (
    <div className={hasArticles ? "related-container" : ""}>
      {hasArticles && (
        <div>
          <div className="related-heading heading area-l">
            {isEmptyString(relatedTitle) ? "Les også" : relatedTitle}
            <div className="related-heading-line" />
          </div>
          <div className="related area-l">
            {articles.map((article) => ArticleCard({ article, context: "Related", showIngress }))}
          </div>
        </div>
      )}
      {!isEmptyString(magazineUrl) && (
        <div className="related-link " style="text-align: center;">
          <a className="link--large" href={magazineUrl}>
            ice-magasinet forside
          </a>
        </div>
      )}
    </div>
  );
};
